import React from "react";
import {
  Table,
  Container,
} from "react-bootstrap";
import { FaEye } from "react-icons/fa";
import { Link } from "react-router-dom";
import { formatDate } from "../../../helper/helper";
import LottiLoader from "../../../components/shared/Loader/LottiLoader";
import { FaUser } from "react-icons/fa6";

const TableList = ({ userData, setUser, fetchedGetMatrimonial, pageLoader, currentPage, rowsPerPage }) => {
  return (
    <div className="card overflow-hidden all-tables">
      <div className="">
        <div className="table-responsive">
          <Table responsive="md" className="mb-0">
            <thead>
              <tr>
                <th>S.N</th>
                <th>Name</th>
                <th>Email</th>
                <th>Mobile No</th>
                <th>Created At</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>
            {!pageLoader && userData?.length !== 0 && (
              <tbody>
                {userData &&
                  userData?.length > 0 &&
                  userData?.map((item, index) => {
                    return (
                      <tr>
                        <td>
                          <strong className="text-black">{(currentPage - 1) * rowsPerPage + index + 1}</strong>
                        </td>
                        <td>
                          {item?.userDetail?.firstName} {item?.userDetail?.lastName}
                        </td>
                        <td>{item?.userDetail?.email}</td>
                        <td>{item?.userDetail?.mobile}</td>
                        <td>{formatDate(item?.createdAt)}</td>
                        <td className="text-center">
                          <div className="d-flex align-items-center justify-content-center">

                            <Link
                              to={`/member-view/${item?.userDetail?._id}`}
                              className="text-black fs-5 px-1"
                              title="View User"
                            >
                              <FaUser />
                            </Link>
                            <Link
                              to={`/view-biodata/${item?.matrimonialId}`}
                              className="text-black fs-5 px-1"
                              title="View Bio Data"
                            >
                              <FaEye />
                            </Link>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            )}

            {userData?.length < 0 && (
              <tbody>
                <tr className="text-center" colspan={7}>
                  <td colspan={7}>No Record Found</td>
                </tr>
              </tbody>
            )}
          </Table>

          {pageLoader && (
            <Container className="d-flex justify-content-center align-items-center default-back">
              <span>
                <LottiLoader height={120} width={120} loader={true} />
              </span>
            </Container>
          )}
        </div>
      </div>
    </div>
  );
};

export default TableList;
